import React from 'react';
import { Link } from 'react-router-dom';

const AuthCard = ({ children, logo, title, subtitle }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <div className="flex flex-col items-center mb-6">
          {logo && (
            <div className="mb-4">
              <img src={logo} alt="Logo" className="h-10 bg-black" />
            </div>
          )}
          <h2 className="text-center text-2xl font-bold">{title}</h2>
          {subtitle && <p className="text-gray-500 text-sm mt-1">{subtitle}</p>}
        </div>
        {children}
      </div>
    </div>
  );
};

export default AuthCard;